import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { WhoWeAre } from "./components/landing/WhoWeAre";
import { TextSection } from "./components/landing/TextSection";
import { ServiceEngines } from "./components/landing/ServiceEngines";
import { IndustryValidation } from "./components/landing/IndustryValidation";
import { WhyUs } from "./components/landing/WhyUs";
import { Contact } from "./components/landing/Contact";
import { Footer } from "./components/landing/Footer";
import BurgerDemo from "./components/BurgerDemo";

const Landing = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="landing-page"
      className="relative min-h-screen bg-[#FBFBFD] text-slate-900"
    >
      <Header />
      <main>
        <Hero
          onCtaServices={() => scrollTo("services")}
          onCtaValidation={() => scrollTo("validation")}
        />

        {/* Who We Are */}
        <WhoWeAre />

        {/* Services */}
        <ServiceEngines />

        {/* Industry Validation */}
        <IndustryValidation />

        {/* Why City AI Studio */}
        <WhyUs />

        {/* Operating Philosophy */}
        <TextSection
          id="philosophy"
          testId="philosophy-section"
          eyebrow="Operating Philosophy"
          title="Business outcomes"
          titleAccent="over buzzwords."
          body="We map AI to revenue, cost and risk — not to hype cycles. Strategy first, then the right technology. Every engagement is scoped to a clear KPI and a defensible architecture."
          variant="muted"
        />

        {/* Contact */}
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0B0E14",
            color: "#ffffff",
            border: "1px solid #1F2937",
            borderRadius: "9999px",
            padding: "12px 18px",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/demo-burger" element={<BurgerDemo />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
